// utils/buildWorkListParams.ts
import { WorkFilterData } from '../../shared/dto/EntityRepository';
import { PerPage } from "../../shared/enum/EnumRepository";

export function buildWorkListParams(
  aui: string,
  metaData: { page: number; size: PerPage; sortData: { sort: string; direction: 'ASC' | 'DESC' } },
  filter: WorkFilterData
): URLSearchParams {
  const p = new URLSearchParams();

  // 기본 메타
  p.set("aui", aui);
  p.set("page", String(metaData.page));
  p.set("size", String(metaData.size));
  p.set("sortBy", metaData.sortData.sort);
  p.set("direction", metaData.sortData.direction);

  // workType: { [key in WorkType]: boolean } -> types=...&types=...
  Object.entries(filter.workType)
    .filter(([, on]) => on)
    .forEach(([t]) => p.append("types", t)); // ex) ?types=PAINTING&types=SCULPTURE

  const setNum = (k: string, v?: number | null) => {
    if (v !== null && v !== undefined) p.set(k, String(v));
  };

  setNum("prodYearMin", filter.prodYear?.min);
  setNum("prodYearMax", filter.prodYear?.max);

  filter.tagIds.forEach((id) => p.append("tagIds", String(id)));
  filter.creditIds.forEach((id) => p.append("creditIds", String(id)));

  return p;
}
